// Release notes live in ./notes, one Markdown file per release, named after the version it ships in
// (`0.3.0-beta.md`, matching the version given to publish.ps1). Vite collects them at build time
// and emits each as a content-hashed static file, so there's no index to keep up to date, and a note
// is only downloaded when it is about to be shown. `no-inline` keeps Vite from embedding these small
// files into the bundle as data URLs.

export interface ReleaseNoteFile {
    version: string;
    /** Where the built app serves the file. */
    url: string;
}

const notes = import.meta.glob<string>('./notes/*.md', {query: '?url&no-inline', import: 'default', eager: true});

export const RELEASE_NOTE_FILES: ReleaseNoteFile[] = Object.entries(notes).map(([path, url]) => ({
    version: path.slice(path.lastIndexOf('/') + 1, -'.md'.length),
    url,
}));
